import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { HttpServerLinkedService } from 'app/model/linkedservice/http-server.linkedservice';
import { HttpFileDataset } from 'app/model/dataset/http-file.dataset';
import { Constants } from 'app/shared/shared-constants';
import { format } from 'app/shared/utils/string.util';
import { maxConcurrentConnectionsMetadata } from '../consts/metadata-consts';

export const httpFileMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(HttpFileDataset).name,
    displayName: stringResources.HttpServer_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(HttpServerLinkedService).name],
    isSource: true,
    isSink: false,
    datasetKind: 'file',
    icon: {
        className: 'svg-i-100x100-HTTP'
    },
    isFirstClass: true,
    supportRootFolder: true,
    category: ['GenericProtocol'],
    copySourceControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'httpRequestTimeout',
                label: stringResources.ModelName_Request_Timeout,
                validators: [
                    {
                        type: 'pattern',
                        pattern: Constants.timeoutValidationPattern,
                        errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_Request_Timeout)
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        },
        maxConcurrentConnectionsMetadata
    ]
};
